import { z } from 'zod';

/**
 * Rejection codes returned for actions and requests. Infrastructure codes are stable;
 * modules may reuse them (e.g. `not_your_turn`, `invalid_move`) or return `module_rule`
 * with a message for rule-specific rejections.
 */
export const RejectCode = z.enum([
  'unauthenticated',
  'unknown_session',
  'session_ended',
  'invite_expired',
  'capacity',
  'invalid_payload',
  'forbidden',
  'wrong_phase',
  'paused',
  'stale_version',
  'duplicate_action',
  'instance_not_active',
  'deadline_passed',
  'rate_limited',
  'not_your_turn',
  'invalid_move',
  'unsupported_participant_count',
  'invalid_team_config',
  'module_not_found',
  'unknown_action',
  'participant_not_found',
  'slot_taken',
  'module_rule',
  'protocol_mismatch',
  'internal',
]);
export type RejectCode = z.infer<typeof RejectCode>;

export interface Rejection {
  code: RejectCode;
  message?: string;
}
